@if(loading) {
<div class="spinner-container">
  <div class="loading-spinner" id="page-loading-spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
</div>
}